import { useFormik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import ButtonStyled from '~/components/Buttons/SimpleButton';
import MaskedInput from '~/components/Inputs/MaskedInput';
import PasswordInput from '~/components/Inputs/PasswordInput';
import { Creators as CommandActions } from '~/store/modules/command/duck';

import {
  ModalContainer,
  Title,
  Descripition,
  ButtonsContainer,
  Field,
} from './styles';

function Modal() {
  const dispatch = useDispatch();
  const { device, id } = useSelector((state) => state.command.tracker);

  const formik = useFormik({
    initialValues: {
      stoped: '480',
      running: '30',
      password: '',
    },
    validate: (value) => {
      const err = {};
      if (!value.stoped) err.stoped = 'Campo obrigatório!';
      if (!value.running) err.running = 'Campo obrigatório!';
      if (!value.password) err.password = 'Campo obrigatório!';
      return err;
    },
    onSubmit: (data) => {
      let msg;
      if (device.model === 'SUNTECH') {
        msg = `ST300RPT;${device.imei};02;${data.stoped};${data.running};${data.running};3;0;200;0;0;0`;
      } else if (device.model === 'QUECLINK') {
        msg = `AT+GTFRI=gv75,1,1,,1,0000,0000,,${data.running},1000,1000,,0,${data.stoped},0,,,,FFFF$`;
      }
      if (data.stoped < '30') {
        toast.warn('O valor minimo do tempo parado é de 480s');
      } else if (data.running < '30') {
        toast.warn('O valor minimo do tempo em movimento é de 30s');
      } else {
        dispatch(
          CommandActions.createCommand({
            phone: device.phone,
            command: msg,
            value: 'timerUpdate',
            tracker_id: id,
            type: 'TIMER',
            password: data.password,
          })
        );
      }
    },
  });

  function closeModal() {
    dispatch(CommandActions.setViewModal(null));
  }

  return (
    <ModalContainer onSubmit={formik.handleSubmit}>
      <Title>Tempo de transmissão</Title>
      <Descripition>
        <Field>
          <div>Tempo parado</div>
          <MaskedInput
            placeholder="Digite o tempo Parado"
            mask="9999"
            name="stoped"
            type="tel"
            onChange={formik.handleChange}
            value={formik.values.stoped}
            error={!!(formik.touched.stoped && formik.errors.stoped)}
          />
        </Field>
        <Field>
          <div>Tempo em movimento</div>
          <MaskedInput
            placeholder="Digite o tempo em movimento"
            mask="9999"
            name="running"
            type="tel"
            onChange={formik.handleChange}
            value={formik.values.running}
            error={!!(formik.touched.running && formik.errors.running)}
          />
        </Field>
        <PasswordInput
          color="#333"
          required
          placeholder="senha"
          name="password"
          onChange={formik.handleChange}
          value={formik.values.password}
          error={!!(formik.touched.password && formik.errors.password)}
        />
      </Descripition>
      <ButtonsContainer>
        <ButtonStyled
          bg="#ff4e4e"
          color="#eee"
          onClick={() => closeModal()}
          text="Cancelar"
        />

        <ButtonStyled type="subbmit" bg="#01659e" color="#eee" text="Enviar" />
      </ButtonsContainer>
    </ModalContainer>
  );
}

export default Modal;
